module.exports = __webpack_public_path__ + "static/img/neck_max.2301e50e.png";